var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLazyQuery } from '@apollo/client';
import { SPORT_EVENT_USERS_SEARCH } from 'common/graphql/queries/sportEvent/sport-event-users-search';
import SearchBar from 'components/SearchBar/SearchBar';
import { useEffect, useState } from 'react';
import Utils from 'utils/Utils';
import SportEventUsersSearchResultList from './SportEventUsersSearchResultList';
var SportEventUsersDialog = function (_a) {
    var sportEventId = _a.sportEventId, isTeamTournament = _a.isTeamTournament, handleClose = _a.handleClose;
    var _b = useState(''), searchInput = _b[0], setSearchInput = _b[1];
    var _c = useLazyQuery(SPORT_EVENT_USERS_SEARCH), getUsers = _c[0], _d = _c[1], data = _d.data, loading = _d.loading, fetchMore = _d.fetchMore;
    useEffect(function () {
        var execGetUsers = function () {
            getUsers({
                variables: {
                    sportEventId: sportEventId,
                    searchQuery: Utils.prepareSearchInputValue(searchInput) || '',
                    limit: 10,
                    offset: 0
                }
            });
        };
        if (searchInput === '') {
            execGetUsers();
        }
        else {
            var delayDebounceFn_1 = setTimeout(function () {
                execGetUsers();
            }, 500);
            return function () { return clearTimeout(delayDebounceFn_1); };
        }
    }, [searchInput]);
    return (_jsxs("div", __assign({ className: "h-full max-h-full flex-nowrap" }, { children: [_jsx("div", { children: _jsx(SearchBar, { value: searchInput, onSearch: setSearchInput }, void 0) }, void 0), _jsx("div", __assign({ className: "flex xs:pb-16 md:pb-24" }, { children: _jsx(SportEventUsersSearchResultList, { sportEventUsers: data === null || data === void 0 ? void 0 : data.sportEventUsersSearch, isTeamTournament: isTeamTournament, isLoading: loading, loadMore: function () {
                        var _a;
                        var currentLength = ((_a = data === null || data === void 0 ? void 0 : data.sportEventUsersSearch) === null || _a === void 0 ? void 0 : _a.length) || 0;
                        fetchMore({
                            variables: {
                                offset: currentLength
                            }
                        });
                    }, handleClose: handleClose }, void 0) }), void 0)] }), void 0));
};
export default SportEventUsersDialog;
